import { isNil, map } from 'lodash'
import { all, put, select, takeLatest } from 'redux-saga/effects'

import { formSettings as formActions } from '../constants/actions'
import { files, formSettings } from '../constants/endpoints'
import { getFormId, getSubdomain } from '../selectors'
import { getClientTime, getSubdomain as getSubdomainPath } from '../utils/common'
import { get } from '../utils/request'

function* getFormSettings() {
  const subdomain = yield select(getSubdomain)
  const sd = getSubdomainPath()
  let formId = yield select(getFormId)
  let response

  if (!formId && window) {
    // If it is not stored in state
    const queryString = window.location.href
    const urlParams = new URLSearchParams(queryString)
    formId = urlParams.get('formId')
  }

  if (formId) {
    response = yield get({
      endpointId: formSettings.getFormSettings,
      params: { form: formId },
    })
  } else if (subdomain) {
    response = yield get({
      endpointId: formSettings.getFormSettings,
      params: { subdomain },
    })
  } else if (sd) {
    response = yield get({
      endpointId: formSettings.getFormSettings,
      params: { subdomain: sd },
    })
  }
  if (isNil(response) || !response.success) {
    yield put(formActions.getFormSettingsError())
  }

  const currentTime = yield getClientTime()

  let settings = response.data
  if (settings) {
    const images = yield processFormSettingImages({
      orgLogo: settings.orgLogo,
      landingPageImage: settings.landingPageImage,
      landingPageLogo: settings.landingPageLogo,
      eventLogo: settings.eventLogo,
    })

    // Resolve custom link images from organisation data
    const org = settings.organisation || {}
    const customLinkImageKeys = {}
    if (org.customLink1Image) customLinkImageKeys.customLink1Image = org.customLink1Image
    if (org.customLink2Image) customLinkImageKeys.customLink2Image = org.customLink2Image
    if (org.customLink3Image) customLinkImageKeys.customLink3Image = org.customLink3Image
    const customLinkImages = yield processFormSettingImages(customLinkImageKeys)

    if (Object.keys(customLinkImages).length > 0) {
      settings = {
        ...settings,
        organisation: {
          ...org,
          ...customLinkImages,
        },
      }
    }

    settings = {
      ...settings,
      ...images,
      currentTime,
    }
    yield put(formActions.setFormSettings(settings))
  } else {
    yield put(formActions.getFormSettingsError())
  }
}

function* processFormSettingImages(links) {
  const keys = []
  const sagas = map(links, (v, k) => {
    keys.push(k)
    return get({
      endpointId: files.download,
      params: {
        key: v,
        isImage: true,
      },
    })
  })
  const response = yield all(sagas)
  const images = keys.reduce((a, v, i) => {
    const image = response[i].data
    // eslint-disable-next-line no-param-reassign
    a[v] = image
    return a
  }, {})

  return images
}

export function* runFormSettingsSagas() {
  yield takeLatest(formActions.GET_FORM_SETTINGS, getFormSettings)
}
